/******************************************************************************************
 *	Purchase Details Modal
 ******************************************************************************************/
(function() {
  angular
    .module('rcControllers.purchaseDetailsModal', [])
    .factory(
      'PurchaseDetailsModal',
      /* @ngInject */
      function(modal) {
        return modal({
          templateUrl: 'views/partials/modals/purchase-details-modal.html',
          controller: 'PurchaseDetailsModalController',
          classNames: 'purchase-details-modal'
        });
      }
    )
    .controller(
      'PurchaseDetailsModalController',
      /* @ngInject */
      function($scope, PurchaseDetailsModal, PaStatus) {
        //Expose PaStatus methods to view
        $scope.PaStatus = PaStatus;

        //Close modal
        $scope.removeModal = function() {
          //Closing the modal via the "X" or "Cancel" buttons will resolve the promise with an object containing a true `cancelled` property
          PurchaseDetailsModal.remove({cancelled: true});
        };
      }
    );
})();
